import { render, staticRenderFns } from "./questionAnswerAly.vue?vue&type=template&id=5bf86ab4&scoped=true"
import script from "./questionAnswerAly.vue?vue&type=script&lang=js"
export * from "./questionAnswerAly.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerAly.vue?vue&type=style&index=0&id=5bf86ab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf86ab4",
  null
  
)

export default component.exports